module.exports = __webpack_public_path__ + "img/aim.959c0f20.svg";